import * as stylex from '@stylexjs/stylex';
import { styles } from '../../styles';
import { SemiCircleProgress } from '../SemiCircleProgress';
import { jsx as _jsx } from "react/jsx-runtime";
export const RangeBar = _ref => {
  let {
    value
  } = _ref;
  if (-5 <= value && value <= 5) {
    value = 50;
  } else if (value < 0) {
    value = 50 - Math.abs(value);
  } else {
    value = value + 50;
  }
  return /*#__PURE__*/_jsx("div", {
    ...stylex.props(styles.rangeBar),
    children: /*#__PURE__*/_jsx(SemiCircleProgress, {
      percentage: value,
      background: "#D85050",
      orientation: "down",
      diameter: 250
    })
  });
};